import { I18nMessages } from "../../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages";

export const frTags: I18nMessages = {
    'tags.navbar': 'Tags',
    'tags.name': 'Tags',
    'tags.title': 'Tags',

    //* TAG LIST
    'tags.list.pageTitle': 'Tags',
    'tags.list.actions.addTag': 'Ajouter un tag',
    'tags.list.table.header.info': 'Tags',
    'tags.list.table.emptyLabel': "Il n'y a pas de tags pour le moment",

    //* TAG INFORMATIONS
    'tags.info.title': 'Titre du tag',
    'tags.info.titlePlaceholder': 'Saisissez ici le titre du tag *',
    'tags.info.description': 'Saisissez ici la description du tag',

    //* TAG CREATE & DETAILS
    'tags.create.pageTitle': 'Création tag',
    'tags.details.actions.previous': 'Tags',
    'tags.details.pageTitle': 'Details tag',

    //* REMOVE TAG
    'tags.remove.dialog.title': 'Suppression du tag',
    'tags.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce tag ?',

    //* TAG SHOP
    'tags.shop.addTagSectionTitle': 'Tags',

    //* TAG AUDIENCE
    'tags.audiences.addTagTitle':
        'Ajouter des centres à l’audience en cliquant sur les tags correspondants au critère voulu :',

    'tags.audiences.tagAdded.title': 'Bien joué !',
    'tags.audiences.tagAdded.content': '{count} centre(s) ajouté(s) à l’audience.',

    'tags.audiences.tagsAlreadyInAdded.title': 'Déjà présent(s) !',
    'tags.audiences.tagsAlreadyInAdded.content': 'Le(s) centre(s) sont déjà dans l’audience.',

    'tags.audiences.item.title': '{title} ({count})',
};
